OffreValidator.$inject = ['validator'];

export default function OffreValidator(validator) {
    const instance = new validator();

    return instance;
}
